<template>
  <svg class="icon" aria-hidden="true">
    <use :href="href"></use>
  </svg>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const href = computed(() => {
      const icons = require("@/assets/icons/icons.svg");
      return `${icons}#${props.icon}`;
    });

    return {
      href,
    };
  },
};
</script>

<style lang="scss">
// Set the width and height to the size of one capital letter
.icon {
  width: 0.75em;
  width: 1cap;
  height: 0.75em;
  height: 1cap;

  // Exception to adjust the size to a lowercase character
  &[data-case="lower"] {
    width: 0.55em;
    width: 1ex;
    height: 0.55em;
    height: 1ex;
  }
}

// If one space is not enough, use this class for the icons parent.
.with-icon {
  display: inline-flex;
  align-items: baseline;

  // Space between the icon and text
  .icon {
    margin-inline-end: var(--icon-margin, var(--space-2xs-xs));
  }
}
</style>
